import { FormGroup, AbstractControl, ValidatorFn, AsyncValidatorFn } from '@angular/forms';
import { FormService } from './form.service';
import { ServiceLocator } from '../../ServiceLocator';
import { ValidationExecutionDTO } from '../../api/plyca-dtos-v2';

export class TableFormGroup extends FormGroup {

  private formService: FormService;

  constructor(private name: string, controls: {
    [key: string]: AbstractControl;
  }, validator?: ValidatorFn | null, asyncValidator?: AsyncValidatorFn | null) {
    super(controls, validator, asyncValidator);
    this.formService = ServiceLocator.injector.get(FormService);
  }

  /**
   * Registers a control with the group's list of controls.
   *
   * This method does not update value or validity of the control, so for
   * most cases you'll want to use {@link FormGroup#addControl} instead.
   */
  registerControl(name: string, control: AbstractControl): AbstractControl {
    let formGroupErrors = this.getControlsErrorMap();
    // eliminar el control
    let abstractControl = super.registerControl(name, control);
    // restablecer error controles
    this.restoreControlErrors(formGroupErrors);
    return abstractControl;
  }
  /**
   * Add a control to this group.
   */
  addControl(name: string, control: AbstractControl): void {
    let formGroupErrors = this.getControlsErrorMap();
    // eliminar el control
    super.addControl(name, control);
    // restablecer error controles
    this.restoreControlErrors(formGroupErrors);
  }
  /**
   * Remove a control from this group.
   */
  // removeControl(name: string): void {
  //   let formGroupErrors = this.getControlsErrorMap(name);
  //   // eliminar el control
  //   super.removeControl(name);
  //   // restablecer error controles
  //   this.restoreControlErrors(formGroupErrors);
  // }

  public removeRow(index: number, rowControlNames?: Array<string> | null, tableJsonPath?: string | null): void {
    let formGroupErrors: Map<any, any>;
    if (rowControlNames) {
      formGroupErrors = this.getControlsErrorMap(this.name);
      rowControlNames.forEach(name => super.removeControl(name));
      this.markAsDirty();
      // restablecer error controles
      this.restoreControlErrors(formGroupErrors);
    } else {
      formGroupErrors = this.getRowErrors(tableJsonPath);
      // actualizar indices errores
      this.restoreRowErrors(index, tableJsonPath, formGroupErrors);
    }
  }

  private restoreRowErrors(indexToDelete: number, tableJsonPath: string, rowErrorMap: Map<number, any>): void {
    rowErrorMap.forEach((value: any, index: number) => {
      let serverErrors = value as ValidationExecutionDTO;
      if (index > indexToDelete) {
        // decrementar en 1 el indice
        serverErrors.jsonPath = this.decreaseRowPath(serverErrors.jsonPath, tableJsonPath);
      }
      if (index !== indexToDelete) {
        this.formService.setFormControlError(this, serverErrors);
      }
    });
  }

  private decreaseRowPath(path: string, tableJsonPath: string): string {
    let regExp = new RegExp(tableJsonPath + '\\[(\\d+)\\](\\..+)');
    let matches = path.match(regExp);
    return tableJsonPath + '[' + (Number(matches[1]) - 1) + ']' + matches[2];
  }

  private getRowErrors(tableJsonPath: string): Map<number, any> {
    let rowErrorMap = new Map<number, any>();
    if (this.errors && this.errors.server) {
      this.errors.server.forEach(error => rowErrorMap.set(this.getRowIndexFromPath(error.jsonPath, tableJsonPath), error))
    }
    return rowErrorMap;
  }

  private getRowIndexFromPath(errorPath: string, tableJsonPath: string): number {
    let regExp = new RegExp(tableJsonPath + '\\[(\\d+)\\]');
    let matches = errorPath.match(regExp);
    return Number(matches[1]);
  }

  private getControlsErrorMap(controlNameToExclude?: string): Map<string, any> {
    let controlsErrorMap = new Map<string, any>();
    let controKeys = Object.keys(this.controls);
    if (controlNameToExclude) {
      controKeys = controKeys.filter((key: string) => key !== controlNameToExclude);
    }
    // almacenar los errores de todos los controles excepto el eliminado
    controKeys.forEach((key: string) => {
      let controlErrors = this.get(key).errors;
      if (controlErrors) {
        controlsErrorMap.set(key, this.get(key).errors);
      }
    });
    return controlsErrorMap;
  }

  private restoreControlErrors(controlsErrorMap: Map<string, any>): void {
    controlsErrorMap.forEach((value: any, key: string) => {
      if (this.get(key) != null)
        this.get(key).setErrors(value);
    });
    // actualizar errores del grupo
    Array.from(controlsErrorMap.values())
      .filter((error: any) => error.server)
      .forEach((error: any) => {
        let serverErrors = error.server as ValidationExecutionDTO;
        this.formService.setFormControlError(this, serverErrors);
      })
  }

}
